import { useQueryClient } from '@tanstack/react-query';

import type { NectarPageBlock } from '~/utils/nectarPageBlock';
import { withNectarTrackingParams } from '~/utils/nectarTracking';

import { useCommunityActionBase } from './useCommunityActionBase';
import { invalidateCommunityFeedQueries } from './useCommunityFeedActionMutation';
import { communityMemberBlocksKeys } from './useCommunityMemberBlocks';

const BLOCK_MEMBER_ACTION = '/community_member_block';

const COMMUNITY_CHAT_TOKEN_QUERY_PREFIX = 'communityChatToken';

interface BlockMemberVars {
  memberId: string;
  block: boolean;
  pageBlock?: NectarPageBlock;
}

export const useBlockMemberMutation = () => {
  const queryClient = useQueryClient();

  return useCommunityActionBase<BlockMemberVars>({
    buildRequest: ({ memberId, block, pageBlock }) => ({
      path: BLOCK_MEMBER_ACTION,
      fields: withNectarTrackingParams({ member_id: memberId, action_type: block ? 'block' : 'unblock' }, pageBlock),
    }),
    onSettled: () => {
      invalidateCommunityFeedQueries(queryClient);
      queryClient.invalidateQueries({ queryKey: [COMMUNITY_CHAT_TOKEN_QUERY_PREFIX] });
      queryClient.invalidateQueries({ queryKey: communityMemberBlocksKeys.all });
    },
  });
};
